export default {
  EmployeeAddEditCompanyDataTabAccess: 'EmployeeAddEditCompanyDataTabAccess',
};
